import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional().nullable(),
  ngay_ct2: z.string().optional().nullable(),
  so_ct1: z.string().nullable(),
  so_ct2: z.string().nullable(),
  loai_du_lieu: z.string().nullable(),
  tl_yn: z.boolean(),

  ma_nv: z.string().nullable(),
  ma_kh: z.string().nullable(),
  nh_kh1: z.string().nullable(),
  nh_kh2: z.string().nullable(),
  nh_kh3: z.string().nullable(),
  rg_code: z.string().nullable(),
  ma_vt: z.string().nullable(),
  ma_lvt: z.string().nullable(),
  ton_kho_yn: z.boolean().nullable(),
  nh_vt1: z.string().nullable(),
  nh_vt2: z.string().nullable(),
  nh_vt3: z.string().nullable(),
  ma_kho: z.string().nullable(),
  ma_unit: z.string().nullable(),
  mau_bc: z.number().nullable(),

  ma_bp: z.string().nullable(),
  ma_vv: z.string().nullable(),
  ma_hd: z.string().nullable(),
  ma_dtt: z.string().nullable(),
  ma_ku: z.string().nullable(),
  ma_phi: z.string().nullable(),
  ma_sp: z.string().nullable(),
  ma_lsx: z.string().nullable(),
  ma_cp0: z.string().nullable(),

  ma_gd: z.string().nullable(),
  tk_vt: z.string().nullable(),
  tk_dt: z.string().nullable(),
  tk_gv: z.string().nullable(),
  ma_lo: z.string().nullable(),
  ma_vi_tri: z.string().nullable(),
  dien_giai: z.string().nullable(),
  report_filtering: z.string().nullable(),
  data_analysis_struct: z.string().nullable()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  so_ct1: '',
  so_ct2: '',
  loai_du_lieu: '1',
  tl_yn: false,
  ma_nv: null,
  ma_kh: '',
  nh_kh1: '',
  nh_kh2: '',
  nh_kh3: '',
  rg_code: '',
  ma_vt: '',
  ma_lvt: '',
  ton_kho_yn: true,
  nh_vt1: '',
  nh_vt2: '',
  nh_vt3: '',
  ma_kho: '',
  ma_unit: '',
  mau_bc: 20,
  ma_bp: '',
  ma_vv: '',
  ma_hd: '',
  ma_dtt: '',
  ma_ku: '',
  ma_phi: '',
  ma_sp: '',
  ma_lsx: '',
  ma_cp0: '',
  ma_gd: '',
  tk_vt: '',
  tk_dt: '',
  tk_gv: '',
  ma_lo: '',
  ma_vi_tri: '',
  dien_giai: '',
  report_filtering: '0',
  data_analysis_struct: '0'
};
